import React from 'react'
import ReactDOM from 'react-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { setBreadcrumb } from '../actions/breadcrumb'
import { fetchShipback } from '../actions/shipback'

import { INSTRUCTIONS } from '../assets/constant'



class ReturnInstructions extends React.Component {

  constructor(props) {
    super()
    this.props = props
    this.state = { steps: ["prepare", "pack", "stick", "done"], intervals: [] }
  }

  componentWillMount() {
    this.props.setBreadcrumb(INSTRUCTIONS)
    var interval = setInterval(() => {this.refreshLabels()}, 5000)
    this.setState({intervals: [...this.state.intervals, interval]})
    setTimeout(() => { clearInterval(interval) }, 90000)

  }

  refreshLabels() {
    this.props.fetchShipback(shipback_id, this.props.user_token, true)
    if (this.props.shipback.label_url != undefined && this.props.shipback.voucher_url) {
      for (var i = 0; i < this.state.intervals.length; i++) {
        clearInterval(this.state.intervals[i])
      }
    }
  }

  renderStep(step, index) {
    var instruction = "shipbacks.confirmations.tutorial.steps." + step + ".title"
    var details_html = "shipbacks.confirmations.tutorial.steps." + step + ".details_html"
    return (
      <div className="row step" key={step}>
        <div className="col-2 offset-1">
          <span className="number pull-right">{ index + 2 }</span>
        </div>
        <div className="col-8">
          <p className="instruction">{I18n.t(instruction)}</p>
          <p className="details"><span dangerouslySetInnerHTML={{__html: I18n.t(details_html)}}></span></p>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="tutorial">
        <h3>{I18n.t('shipbacks.confirmations.tutorial.title')}</h3>
        <p className="subtitle">{I18n.t('shipbacks.confirmations.tutorial.subtitle')}</p>
        <div className="row step">
          <div className="col-2 offset-1">
            <span className="number pull-right">1</span>
          </div>
          <div className="col-8">
            <p className="instruction">{I18n.t('shipbacks.confirmations.tutorial.steps.download.title')}</p>
            <p className="details"><span dangerouslySetInnerHTML={{__html: I18n.t('shipbacks.confirmations.tutorial.steps.download.details_html')}}></span></p>
            <div className="download row text-center">
              <div className="col-12">
                <a href={this.props.shipback.voucher_url ? this.props.shipback.voucher_url : "#"} target={this.props.shipback.voucher_url ? "_blank" : ""} className={this.props.shipback.voucher_url ? "enabled" : "disabled"}>
                 {this.props.shipback.voucher_url ? I18n.t('shipbacks.confirmations.tutorial.steps.download.voucher') :
                  <span>
                    <i className="fetch fa fa-2x fa-spinner fa-spin"/>&nbsp;
                    {I18n.t('shipbacks.confirmations.tutorial.steps.fetching.voucher')}
                  </span> }
                </a><br/>
                <a href={this.props.shipback.label_url ? this.props.shipback.label_url : "#"} target={this.props.shipback.label_url ? "_blank" : ""} className={this.props.shipback.label_url ? "enabled" : "disabled"}>
                   {this.props.shipback.label_url ? I18n.t('shipbacks.confirmations.tutorial.steps.download.return_label') :
                    <span>
                      <i className="fetch fa fa-2x fa-spinner fa-spin"/>&nbsp;
                      {I18n.t('shipbacks.confirmations.tutorial.steps.fetching.return_label')}
                    </span>}
                </a>
              </div>
            </div>
          </div>
        </div>
        {
          this.state.steps.map((step, index) => (
            this.renderStep(step, index)
          ))
        }
      </div>
    )
  }
}

const mapStateToProps = state => ({
  shipback: state.shipback,
  user_token: state.user
})

const mapDispatchToProps = dispatch => bindActionCreators({ setBreadcrumb, fetchShipback }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(ReturnInstructions)


// WEBPACK FOOTER //
// ./app/javascript/components/components/ReturnInstructions.jsx